<template>
    <el-dialog
        :title="$t('图片剪裁')"
        :visible.sync="show"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="80%"
        :before-close="cancel"
        @closed="loading = false"
    >
        <div class="cropper-content">
            <div class="cropper-hint mb20">{{ $t('裁剪滚轮缩放') }}</div>
            <div
                class="cropper"
                style="text-align:center"
                :style="{height:options.autoCropHeight+'px'}"
            >
                <vueCropper
                    v-if="options.img"
                    ref="cropper"
                    :img="options.img"
                    :output-size="defaultOptions.size"
                    :output-type="defaultOptions.outputType"
                    :info="true"
                    :full="defaultOptions.full"
                    :can-move="defaultOptions.canMove"
                    :can-move-box="defaultOptions.canMoveBox"
                    :original="defaultOptions.original"
                    :auto-crop="defaultOptions.autoCrop"
                    :fixed="defaultOptions.fixed"
                    :fixed-number="options.fixedNumber"
                    :auto-crop-width="options.autoCropWidth"
                    :auto-crop-height="options.autoCropHeight"
                    :center-box="defaultOptions.centerBox"
                    :info-true="defaultOptions.infoTrue"
                    :fixed-box="defaultOptions.fixedBox"
                />
            </div>
        </div>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button @click="cancel">{{ $t('取消') }}</el-button>
            <el-button
                type="primary"
                :loading="loading"
                @click="confirm"
            >
                {{ $t('确定') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { uploadOssByStream } from '@/api/index'

export default {
    name: 'BaseCropper',
    props: {
        show: {
            default: false
        },
        file: {
            default: undefined
        },
        options: {
            default: () => {
                return { // 裁剪组件的基础配置option
                    img: '', // 裁剪图片的地址
                    fixedNumber: [ 400, 400 ], // 截图框的宽高比例
                    autoCropWidth: 400, // 裁剪宽度
                    autoCropHeight: 400 // 裁剪高度
                }
            }
        }
    },
    data() {
        return {
            loading: false,
            defaultOptions: { // 裁剪默认配置项
                info: true, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                fixedBox: true, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                full: false, // 是否输出原图比例的截图
                canMoveBox: false, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: false, // 截图框是否被限制在图片里面
                infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                enlarge: 1, // 图片根据截图框输出比例倍数
                high: true // 是否按照设备的dpr 输出等比例图片
            }
        }
    },
    mounted() {
    },
    methods: {
        // 获取文件类型
        getFileType(file) {
            const filename = file
            const index1 = filename.lastIndexOf('.')
            const index2 = filename.length
            const type = filename.substring(index1, index2)
            const name = (parseInt(Math.random() * 100000000)).toString()
            return [ name, type ]
        },
        // 确定
        confirm() {
            this.loading = true
            this.$refs.cropper.getCropBlob((data) => {
                const reader = new FileReader()
                reader.readAsDataURL(data)
                reader.onload = async() => {
                    // 这个地方，可以得到 选中了文件的数据量
                    // 获取文件名
                    function getType(file) {
                        const filename = file
                        const index1 = filename.lastIndexOf('.')
                        const index2 = filename.length
                        const type = filename.substring(index1, index2)
                        const name = parseInt(Math.random() * 100000000).toString()
                        return [ name, type ]
                    }

                    let [ name, type ] = getType(this.file.name)
                    name = name.replace(/,/g, '')
                    type = type.replace(/,/g, '')

                    // formData配置
                    const formData = new FormData()
                    const objectName = 'baoli/' + name + '_' + new Date().valueOf() + type
                    formData.append('objectName', objectName)
                    formData.append('file', data)
                    formData.append('bucketName', 'ef-imaster-file')
                    formData.append('bizType', 'IMAGEFILE')

                    // const res = await this.$axios.post(common.uploadOssByStream, formData, true, true, {
                    //     isUpload: true
                    // })
                    const res = await uploadOssByStream(formData, {})

                    if (res.data.code === '0000') {
                        this.$emit('callback', {
                            uid: this.file.uid,
                            url: res.data.data
                        })
                    }

                    this.loading = false
                }
            })
        },
        // 取消
        cancel() {
            this.$emit('closeCropper', this.file)
        }
    }
}
</script>

<style scoped lang="stylus">
.cropper-content {
    .cropper-hint {
        font-size: 16px;
        line-height: 1.5;
        text-align: justify;
        color: $color-main
    }

    .cropper {
        width: auto;
        // height: 400px;
    }
}
</style>
